import { render } from "./UiTabsButtons.vue?vue&type=template&id=02198940&scoped=true&ts=true"
import script from "./UiTabsButtons.vue?vue&type=script&lang=ts"
export * from "./UiTabsButtons.vue?vue&type=script&lang=ts"

import "./UiTabsButtons.vue?vue&type=style&index=0&id=02198940&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02198940"]])

export default __exports__